import {styled} from '@mui/material/styles';
import MaterialSearchIcon from '@mui/icons-material/Search';

export const SearchIcon = styled(MaterialSearchIcon)(({theme}) => ({
    color: theme.tokens.FuelColorGray700
}));
